/**
 * Copyright (c) Microsoft. All rights reserved.
 */

// tslint:disable:no-any
// tslint:disable:export-name

/** Wrapper to send request with specified timeout */
// tslint:disable-next-line:promise-function-async
export function fetchWithTimeout(request: Request, timeoutMs: number): Promise<Response> {
    let timeoutId: number | undefined;
    const fetchPromise = new Promise<Response>((resolve, reject) => {
        fetch(request).then((response) => {
            clearTimeout(timeoutId);
            resolve(response);
        }).catch((error) => {
            clearTimeout(timeoutId);
            reject(error);
        });
    });
    if (timeoutMs !== 0) {
        const timeoutPromise = new Promise<Response>((resolve, reject) => {
            // tslint:disable-next-line:no-string-based-set-timeout - false positive
            timeoutId = setTimeout(reject, timeoutMs, new Error(`Fetch for '${request.url}' timed out`));
          });

        return Promise.race([fetchPromise, timeoutPromise]);
    }

    return fetchPromise;
}

export function toJson(obj: any): string {
    try {
        return JSON.stringify(obj);
    } catch (error) {
        return `Unable to serialize object of type ${typeof obj}`;
    }
}

/**
 * Simplify calculation of time intervals
 */
export class Timespan {
    private start: number;

    constructor() {
        this.start = Date.now();
    }

    /**
     * Returns number of milliseconds from start
     */
    public get duration(): number {
        return Date.now() - this.start;
    }

    /**
     * Returns start time
     */
    public get startTime() {
        return this.start;
    }

    /**
     * Reset start of interval to current timestamp
     */
    public reset() {
        this.start = Date.now();
    }
}



// WEBPACK FOOTER //
// ./lib_temp/Common.ts